// services/mediaService.js
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_URL = `${BASE_URL}/api/media`;

export const getMedias = async (categoria = null) => {
  try {
    const url = categoria ? `${API_URL}?categoria=${categoria}` : API_URL;
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error('Error al cargar las apariciones en medios');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error en getMedias:', error);
    throw error;
  }
};

export const getMedia = async (id) => {
  try {
    const response = await fetch(`${API_URL}/${id}`);
    
    if (!response.ok) {
      throw new Error('Error al cargar la aparición');
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error en getMedia:', error);
    throw error;
  }
};